import { Injectable } from '@angular/core';
import { HttpClient,HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { DocumentRequestList, DocumentRequestSearch, DocumentRequestPublish, DocumentRequest } from '../../../models/api-dam/document/document-request.model';
import { DocumentResponseList, DocumentResponseSearch, DocumentResponsePublish, DocumentResponseGet, DocumentResponse } from '../../../models/api-dam/document/document-response.model';

@Injectable({
  providedIn: 'root'
})
export class DocumentService {

  constructor(private http: HttpClient) { }

  pathUrl:string = environment.backend.pathUrl.dam.document;
  baseUrl:string = environment.backend.baseUrl_dam;
  url:string = this.baseUrl + this.pathUrl;

  
  /**createParams
   * @param objectStoresParams 
   * @returns params
   * Prende in input un oggetto e lo trasforma in un HttpParams
   */
   createParams(objectStoresParams:any){
    let params = new HttpParams();
    for(let property in objectStoresParams) {
      if(objectStoresParams.hasOwnProperty(property)) {
        params = params.append(property, objectStoresParams[property]);
      }
    }
    return params;
  }

 /**getList
   * @param request 
   * @returns Observable DocumentResponseList
   * 
   */
  getList(request:DocumentRequestList):Observable<DocumentResponseList>{
    let url = this.url;
    let params = this.createParams(request);
    return this.http.get<DocumentResponseList>(url,{ params: params });
  }

  /**create
   * 
   * @param request 
   * @param file 
   * @returns Observable DocumentResponse
   */
  create(request:DocumentRequest,file: File):Observable<DocumentResponse>{
    let url = this.url;
    let headers = new HttpHeaders ();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');
    const formData = new FormData();
    formData.append('file', file);
    for(let key in request){
      formData.append('document.'+key, request[key]);
    }
    return this.http.post<DocumentResponse>(url,formData,{headers:headers});
  }

  /**get
   * @param id 
   * @returns  Observable DocumentResponseGet
   */
  getEntity(id:number):Observable<DocumentResponseGet>{
    let url = this.url+"/"+id;
    return this.http.get<DocumentResponseGet>(url);
  }

  /**update
   * 
   * @param id 
   * @param request 
   * @returns Observable DocumentResponse
   */
  update(id:number,request:DocumentRequest):Observable<DocumentResponse>{
    let url = this.url+"/"+id;
    return this.http.put<DocumentResponse>(url,request);
  }


  /**delete
   * 
   * @param id 
   * @returns status
   */
  delete(id:number){
    let url = this.url+"/"+id;
    return this.http.delete<any>(url);
  }

  /**download
   * 
   * @param id 
   * @returns 
   */
  download(id:number):Observable<Blob>{
    let url = this.url+"/"+id+"/download";
    return this.http.get<any>(url,{responseType: 'blob' as 'json'});
  }

  /**publish
   * 
   * @param id 
   * @param published 
   * @returns 
   */
  publish(id:number,published:boolean):Observable<DocumentResponsePublish>{
    let url = this.url+"/"+id+"/publish?published="+published;
    let request = new DocumentRequestPublish();
    request.id = id;
    request.published = published;
    return this.http.put<DocumentResponsePublish>(url,request);
  }

  /**search
   * 
   * @param request 
   * @returns Observable DocumentResponseSearch
   */
  search(request:DocumentRequestSearch):Observable<DocumentResponseSearch>{
    let url = this.url+"/search";
    return this.http.post<DocumentResponseSearch>(url,request);
  }







}
